const adminReducer =(state=[], action)=>{
    switch(action.type){
        case "SET_ADMIN":
            return state=action.payload;
        case "GET_ADMIN":
            return state;
            default:
                return state; 
    }
}

export default adminReducer;